// src/components/footer/FooterAdmin.jsx
/* eslint-disable */
import React from "react";
import {
  Flex, Text, Box, useColorModeValue,
} from "@chakra-ui/react";

const DESKTOP_FOOTER_H = 56;

export default function Footer() {
  const textColor = useColorModeValue("gray.600", "gray.200");
  const bg = useColorModeValue("white", "gray.900");
  const border = useColorModeValue("gray.200", "whiteAlpha.300");

  return (
    <>
      {/* 데스크탑 푸터 */}
      <Flex
        as="footer"
        position="fixed"
        bottom="0"
        left="0"
        right="0"
        h={`${DESKTOP_FOOTER_H}px`}
        bg={bg}
        borderTop="1px solid"
        borderColor={border}
        px={{ base: "20px", md: "40px" }}
        align="center"
        justify="center"
        zIndex={10}
        display={{ base: "none", md: "flex" }}
      >
        <Text color={textColor} fontSize="sm" textAlign="center">
          &copy; {new Date().getFullYear()}
          <Text as="span" ms="6px">
            XI S&amp;D, All Rights Reserved. Designed & Developed by DX Team.
          </Text>
        </Text>
      </Flex>

      {/* 본문이 푸터에 가려지지 않도록 여백 확보 (모바일은 0px) */}
      <Box h={{ base: "0px", md: `${DESKTOP_FOOTER_H}px` }} />
    </>
  );
}
